const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
})

export default styles
